module.exports = __webpack_public_path__ + "img/retrofit-1.0ef8b7a4.jpg";